import { render, staticRenderFns } from "./product_list2.vue?vue&type=template&id=2ec3da26&"
import script from "./product_list2.vue?vue&type=script&lang=js&"
export * from "./product_list2.vue?vue&type=script&lang=js&"
import style0 from "./product_list2.vue?vue&type=style&index=0&id=2ec3da26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports